import { normalizeDateOnly } from '@shared/libs/date-validation';

export const INVALID_DATE_WARNING = 'Неверно указана дата';

export const PRIMARY_REQUIRED_FIELD = 'Обязательное поле';
export const PRIMARY_INVITATION_DATE_FROM_TODAY = 'Выберите дату начиная с сегодняшней';
export const PRIMARY_INVITATION_DATE_BEFORE_TODAY_ALERT = 'Дата не может быть раньше сегодняшнего дня';
export const PRIMARY_INVITATION_BODY_REQUIRED = 'Введите текст приглашения';
export const PRIMARY_ALERT_INVITATION_VS_EVENT_END =
  'Срок действия приглашения не может быть позже даты окончания мероприятия';
export const PRIMARY_ALERT_INVITATION_VS_TICKET_DATE = 'Срок действия приглашения позже даты отправки билетов';

export type PrimaryDateCheck = {
  inline: string | null;
  alert: string | null;
  invalid: boolean;
};

export type EvaluatePrimaryInvitationDateIssueInput = {
  invitationExpiresAt: Date | null;
  eventDateEnd: string | null;
  ticketDate: Date | null;
  ticketsBlockActive: boolean;
};

export function evaluatePrimaryInvitationDateIssue({
  invitationExpiresAt,
  eventDateEnd,
  ticketDate,
  ticketsBlockActive,
}: EvaluatePrimaryInvitationDateIssueInput): PrimaryDateCheck {
  if (!invitationExpiresAt) {
    return { inline: PRIMARY_REQUIRED_FIELD, alert: null, invalid: true };
  }

  const normalizedInvitationDate = normalizeDateOnly(invitationExpiresAt);
  const normalizedToday = normalizeDateOnly(new Date());
  if (normalizedInvitationDate < normalizedToday) {
    return {
      inline: PRIMARY_INVITATION_DATE_FROM_TODAY,
      alert: PRIMARY_INVITATION_DATE_BEFORE_TODAY_ALERT,
      invalid: true,
    };
  }

  const normalizedEventEndDate = eventDateEnd ? normalizeDateOnly(new Date(eventDateEnd)) : null;
  if (normalizedEventEndDate && normalizedInvitationDate > normalizedEventEndDate) {
    return {
      inline: INVALID_DATE_WARNING,
      alert: PRIMARY_ALERT_INVITATION_VS_EVENT_END,
      invalid: true,
    };
  }

  if (!ticketsBlockActive || !ticketDate) {
    return { inline: null, alert: null, invalid: false };
  }

  const normalizedTicketDate = normalizeDateOnly(ticketDate);
  if (normalizedInvitationDate > normalizedTicketDate) {
    return { inline: null, alert: PRIMARY_ALERT_INVITATION_VS_TICKET_DATE, invalid: true };
  }

  return { inline: null, alert: null, invalid: false };
}
